const updateThemeSlideInfo = ({ title, content }) => {
	const slideInfo = document.querySelector('.slide-info');
	slideInfo.classList.add('-hide');

	setTimeout(() => {
		slideInfo.firstChild.innerText = title;
		slideInfo.firstChild.nextSibling.innerText = content;

		slideInfo.classList.remove('-hide');
	}, 500);
};

export default updateThemeSlideInfo;



// WEBPACK FOOTER //
// ./src/js/theme/updateThemeSlideInfo.js